export default __webpack_public_path__ + "static/media/Anurag.6cf4a8e0.jpg";